import { useCallback } from 'react'
import { debounce } from 'lodash'
import prefixUID from 'src/feed/ChatMessageSendingSection/messageLocalStoragePrefixUID'
import { DRAFT_MESSAGE_EVENT_NAME } from 'src/feed/ChatMessageSendingSection/useMessage'
import { readLocal, usePersistedState } from './localStore'

// Standard's draft lifetime (`localStorageWithTTL`'s default) — a draft to a patient is PHI at rest.
const DRAFT_EXPIRY_HOURS = 24

// Standard's `useMessage` debounces the same event; its participant list listens for it.
const announceDraftChange = debounce((uid: string) => {
  window.dispatchEvent(new Event(`${DRAFT_MESSAGE_EVENT_NAME}_${uid}`))
}, 500)

// Standard's draft slot, so a draft typed here shows on both surfaces' draft indicators.
export const usePatientDraft = (uid: string) => {
  const [draft, setStoredDraft] = usePersistedState(prefixUID(uid), '', { expiresInHours: DRAFT_EXPIRY_HOURS })

  const setDraft = useCallback(
    (text: string) => {
      setStoredDraft(text)
      announceDraftChange(uid)
    },
    [setStoredDraft, uid]
  )

  return [draft, setDraft] as const
}

export const readDraftPending = (uid: string): boolean =>
  readLocal(prefixUID(uid), '', { expiresInHours: DRAFT_EXPIRY_HOURS }) !== ''
